module.exports = __webpack_public_path__ + "img/1440.1e40b3f8.jpg";